import Image from 'next/image'

/** Rounded app icon (Sigma + trend) — lives in /public/brand/sigma-mark.png */
const BRAND_SRC = '/brand/sigma-mark.png'

type Props = {
  /** Rendered width/height in CSS pixels */
  size?: number
  className?: string
  priority?: boolean
  /** When false, decorative (parent supplies visible text) */
  /** Empty when parent link has aria-label */
  alt?: string
}

export function SigmaBrandMark({ size = 32, className, priority, alt = '' }: Props) {
  return (
    <Image
      src={BRAND_SRC}
      alt={alt}
      width={512}
      height={512}
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * 0.22),
        objectFit: 'cover',
        flexShrink: 0,
      }}
      priority={priority}
    />
  )
}
